import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from 'ae-components/protected-route/protected-route';

import { AGENT_SETTINGS_READ_CAPABILITY } from '../components/agent-settings/agent-settings-layout/agent-settings-layout';

const AgentSettingsLayout = lazy(
  () =>
    import(
      '../components/agent-settings/agent-settings-layout/agent-settings-layout'
    ),
);
const ContainmentAllowlistPage = lazy(
  () => import('../pages/agent-settings/containment-allowlist.page'),
);
const ConfigurationsPage = lazy(
  () => import('../pages/agent-settings/agent-configurations.page'),
);
const InternalConfigurationsPage = lazy(
  () => import('../pages/agent-settings/agent-internal-configurations.page'),
);
const AgentAdministrationPage = lazy(
  () => import('../pages/agent-settings/agent-administration.page'),
);

export const AgentSettingsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AgentSettingsLayout />}>
        <Route
          element={
            <ProtectedRoute
              capabilityIds={[AGENT_SETTINGS_READ_CAPABILITY]}
              legacyCapabilities={{ canViewAgentSettings: true }}
            />
          }
        >
          <Route path="configuration" element={<ConfigurationsPage />} />
        </Route>
        <Route
          element={
            <ProtectedRoute
              legacyCapabilities={{ canViewAgentSettings: true }}
            />
          }
        >
          <Route
            path="containment-allowlist"
            element={<ContainmentAllowlistPage />}
          />
        </Route>
        <Route
          element={
            <ProtectedRoute
              legacyCapabilities={{ canViewAgentSettings: true }}
            />
          }
        >
          <Route
            path="internal-configuration"
            element={<InternalConfigurationsPage />}
          />
        </Route>
        <Route
          element={
            <ProtectedRoute
              legacyCapabilities={{ canViewAgentSettings: true }}
            />
          }
        >
          <Route
            path="agent-administration"
            element={<AgentAdministrationPage />}
          />
        </Route>
      </Route>
    </Routes>
  );
};
